import {Store} from 'redux';

let store: Store | null = null;

export const isStoreConfigured = (): boolean => !!store;

const getStore = (): Store => {
  if (!store) {
    throw new Error('Redux Store is null.  Ensure you have configured the store prior to calling getStore().');
  }
  return store;
};

export const setStore = (newStore: Store) => {
  store = newStore;
};

export default getStore;
